enum InstallmentFrequency {
    OneTime = 'one-time',
    Weekly = 'weekly',
    Monthly = 'monthly',
    Quarterly = 'quarterly',
    SemiAnnually = 'semi-annually',
    Annually = 'annually',
    Custom = 'custom',
}

enum PaymentType {
    Cash = 'cash',
    Card = 'card',
    Check = 'check',
    InKind = 'in-kind',
    Stock = 'stock',
    Property = 'property',
    Other = 'other',
}

enum PledgeStatus {
    Fulfilled = 'fulfilled',
    Canceled = 'canceled',
    OnSchedule = 'on_schedule',
    OffSchedule = 'off_schedule',
}

enum PledgeStatsInterval {
    Hourly = 'hourly',
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
    Yearly = 'yearly',
}

enum PledgeType {
    Donation = 'donation',
    Sponsorship = 'sponsorship',
    Match = 'match',
    Payroll = 'payroll',
    Other = 'other',
}

export { PledgeStatsInterval, PledgeStatus, PaymentType, InstallmentFrequency, PledgeType };
